<div class="container-gral">
  <!-- Hero Section -->
  <section class="hero text-center text-white d-flex align-items-center justify-content-center" id="home">
  
  </section>

  <!-- Próximos Shows -->
  <!-- Próximos Shows -->
<section id="shows">
  <h2>Próximos Shows</h2>
  <div class="shows-container">
    <div *ngFor="let show of upcomingShows" class="show-item">
      <span class="show-date">
        <i class="fas fa-calendar-alt"></i> &nbsp; {{ show.date }}
      </span>
      <span class="show-location">{{ show.city }}</span>
      <a [href]="show.link" target="_blank" class="show-button">
        {{ show.type === 'buy' ? ' Comprá tu entrada' : ' Más Info' }}
      </a>
    </div>
  </div>
</section>



  <!-- Redes Sociales -->
  <section id="socials">
    <h2 class="animate__animated animate__fadeIn">Seguinos en nuestras redes</h2>
    <div class="socials-container">
      <a *ngFor="let social of socialLinks" [href]="social.link" target="_blank" class="social-button"
        [ngClass]="social.class">
        <i [class]="social.icon"></i> {{ social.name }}
      </a>
    </div>
  </section>

  <!--biografia/nosotros-->
  <app-nosotros></app-nosotros>

  <!--musica-->
  <app-musica></app-musica>
  <!-- Galería -->
  <app-galeria></app-galeria>

  <app-contacto></app-contacto>


</div>